import "core-js/modules/es.array.map";
import "core-js/modules/es.function.name";
import "core-js/modules/es.object.keys";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "D:/mzkj/\u8981\u70BC/yl-pc-business/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _toConsumableArray from "D:/mzkj/\u8981\u70BC/yl-pc-business/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import bankList from '@/const/bank';
import utilRules from '@/libs/rules';

var imgUrl = require('@/assets/image/noPass.png');

var formData = {
  payerAccountName: '',
  depositAmount: undefined,
  payerAccount: '',
  depositImage: '',
  payerBankName: ''
};

var rulelist = _toConsumableArray(Object.keys(formData).map(function (v) {
  return v;
}));

export default {
  data: function data() {
    return {
      imgUrl: imgUrl,
      layer: {
        show: false,
        title: '修改保证金转账信息',
        showButton: true
      },
      options: bankList,
      formData: formData,
      rules: utilRules(rulelist),
      subTitle: '保证金缴纳审核未通过',
      dipostInfo: {}
    };
  },
  methods: {
    // 图片上传
    handleSuccess: function handleSuccess(response, key) {
      this.$set(this.formData, key, this.VUE_APP_IMG_BASE + response.key);
      this.$refs['formData'].clearValidate(key);
    },
    beforeUpload: function beforeUpload(file) {
      if (!YL.beforeUploadCommon(file, 'pic')) return false;
      this.uploadData.data.key = new Date().getTime() + YL.catchType(file.name);
    },
    confirm: function confirm() {
      var _this = this;

      this.$refs.formData.validate( /*#__PURE__*/function () {
        var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(valid) {
          return regeneratorRuntime.wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  if (valid) {
                    _context.next = 2;
                    break;
                  }

                  return _context.abrupt("return");

                case 2:
                  _context.next = 4;
                  return _this.$api.deposit(_this.formData);

                case 4:
                  YL.message('修改成功,等待审核');
                  _this.layer.show = false;
                  YL.isStoreAuto(4);

                case 7:
                case "end":
                  return _context.stop();
              }
            }
          }, _callee);
        }));

        return function (_x) {
          return _ref.apply(this, arguments);
        };
      }());
    },
    dataBind: function dataBind(item) {
      var _this2 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var data;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return _this2.$api.checkTokenStatus(item);

              case 2:
                data = _context2.sent;
                _this2.dipostInfo = data;

              case 4:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }))();
    }
  },
  created: function created() {
    this.dataBind();
    this.getQiNiu();
  }
};